import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';

export const Footer = () => {
  return (
    <footer className="footer" id="contacts">
      <div className="footer-pattern"></div>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img src={siteConfig.logo} alt={siteConfig.companyName} className="footer-logo" />
            <h3 className="footer-company-name">{siteConfig.companyFullName}</h3>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Контакти</h4>
            <div className="footer-contacts">
              <a href={`tel:${siteConfig.phone}`} className="footer-contact-item">
                <Phone size={16} />
                <span>{siteConfig.phone}</span>
              </a>
              <a href={`mailto:${siteConfig.email}`} className="footer-contact-item">
                <Mail size={16} />
                <span>{siteConfig.email}</span>
              </a>
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span>{siteConfig.address}</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Навігація</h4>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">Головна</Link>
              <Link to="/catalog" className="footer-link">Каталог продукції</Link>
            </nav>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} {siteConfig.companyFullName}. Всі права захищені.</p>
        </div>
      </div>
    </footer>
  );
};
